<template>
    <div class="mb-2 flex flex-col gap-1 sm:justify-end sm:flex-row sm:mb-0 sm:gap-2 sm:-mr-4 sm:flex-auto">
        <vx-button
            @click="emit('export')"
            :loading="props.exporting"
            color="muted-dark"
            size="sm"
            outline
            data-test="export-btn"
        >
            <span class="inline sm:hidden md:inline">Export</span>
            <font-awesome-icon :icon="faFileArrowDown" />
        </vx-button>
        <vx-button @click="emit('toggleAll')" color="muted-dark" size="sm" data-test="toggle-all-btn">
            Toggle All
            <font-awesome-icon :icon="props.showingAll ? faSquareMinus : faSquarePlus" />
        </vx-button>
    </div>
</template>

<script setup lang="ts">
import { VxButton } from '@voxie/frontend-components';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faFileArrowDown, faSquareMinus, faSquarePlus } from '@fortawesome/pro-solid-svg-icons';

const props = defineProps<{
    exporting: boolean;
    showingAll: boolean;
}>();

const emit = defineEmits<{
    export: [];
    toggleAll: [];
}>();
</script>
